export default __webpack_public_path__ + "static/media/banner-studio.32e7c3ff.png";